"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppointmentsCalendarQuery = exports.GetAppointmentsCalendarResponse = exports.AppointmentCalendarSchema = exports.UpdateAppointmentResponse = exports.UpdateAppointmentParams = exports.UpdateAppointmentRequest = exports.DeleteAppointmentResponse = exports.DeleteAppointmentParams = exports.GetAppointmentResponse = exports.GetAppointmentParams = exports.GetAppointmentsQuery = exports.GetAppointmentsResponse = exports.CreateAppointmentResponse = exports.CreateAppointmentRequest = exports.AppointmentSchema = exports.AppointmentType = void 0;
const zod_1 = require("zod");
const address_types_1 = require("./address.types");
const attachment_types_1 = require("./attachment.types");
var AppointmentType;
(function (AppointmentType) {
    AppointmentType["VISIT"] = "VISIT";
    AppointmentType["JOB"] = "JOB";
})(AppointmentType || (exports.AppointmentType = AppointmentType = {}));
exports.AppointmentSchema = {
    startDateTime: zod_1.z.string().datetime(),
    endDateTime: zod_1.z.string().datetime(),
    allDay: zod_1.z.boolean(),
    notes: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    customerId: zod_1.z.string(),
    addressId: zod_1.z.string(),
    attachments: zod_1.z.array(zod_1.z.object(attachment_types_1.AttachmentSchema)),
    type: zod_1.z.nativeEnum(AppointmentType).default(AppointmentType.VISIT),
    assignedUserId: zod_1.z.string(),
};
const AppointmentDetailsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    jobId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    quoteId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    assignment: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
    }),
    startDateTime: zod_1.z.string().datetime(),
    endDateTime: zod_1.z.string().datetime(),
    name: zod_1.z.string(),
    allDay: zod_1.z.boolean(),
    customer: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        phoneNumber: zod_1.z.string(),
    }),
    address: address_types_1.NewAddressSchema,
    notes: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    attachments: zod_1.z.array(zod_1.z.object({
        ...attachment_types_1.AttachmentSchema,
    })),
    type: zod_1.z.nativeEnum(AppointmentType),
    googleEventUrl: zod_1.z.string().nullable(),
});
const SingleAppointmentSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
const AppointmentParams = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.CreateAppointmentRequest = zod_1.z.object({
    ...exports.AppointmentSchema,
});
exports.CreateAppointmentResponse = SingleAppointmentSchema;
const AttachmentTypeObject = zod_1.z.object(attachment_types_1.AttachmentSchema);
exports.GetAppointmentsResponse = zod_1.z.object({
    data: zod_1.z.array(AppointmentDetailsSchema),
});
exports.GetAppointmentsQuery = zod_1.z.object({
    startDate: zod_1.z.string().date().optional(),
    endDate: zod_1.z.string().date().optional(),
    limit: zod_1.z.number().optional(),
});
exports.GetAppointmentParams = AppointmentParams;
exports.GetAppointmentResponse = zod_1.z.object({
    data: AppointmentDetailsSchema,
});
exports.DeleteAppointmentParams = AppointmentParams;
exports.DeleteAppointmentResponse = SingleAppointmentSchema;
exports.UpdateAppointmentRequest = zod_1.z.object({
    id: zod_1.z.string(),
    ...exports.AppointmentSchema,
});
exports.UpdateAppointmentParams = AppointmentParams;
exports.UpdateAppointmentResponse = SingleAppointmentSchema;
exports.AppointmentCalendarSchema = zod_1.z.object({
    date: zod_1.z.string().date(),
    type: zod_1.z.string(),
    appointments: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        startTime: zod_1.z.string(),
        endTime: zod_1.z.string(),
        name: zod_1.z.string(),
        allDay: zod_1.z.boolean(),
        type: zod_1.z.nativeEnum(AppointmentType),
    })),
});
const MonthlyCalendarSchema = zod_1.z.array(zod_1.z.array(exports.AppointmentCalendarSchema));
const WeeklyCalendarSchema = zod_1.z.array(exports.AppointmentCalendarSchema);
exports.GetAppointmentsCalendarResponse = zod_1.z.object({
    data: zod_1.z.union([MonthlyCalendarSchema, WeeklyCalendarSchema]),
    meta: zod_1.z.object({
        totalAppointments: zod_1.z.number(),
    }),
});
var ViewType;
(function (ViewType) {
    ViewType[ViewType["month"] = 0] = "month";
    ViewType[ViewType["week"] = 1] = "week";
})(ViewType || (ViewType = {}));
exports.GetAppointmentsCalendarQuery = zod_1.z.object({
    date: zod_1.z.string().date().optional(),
    view: zod_1.z.nativeEnum(ViewType).default(ViewType.month),
});
